'use client';
import Link from 'next/link';
import type { MemoryDockOperation } from '../../lib/operationDockMemory';
import { useTranslation } from '../../lib/i18n';
import { Button, buttonClassName } from '../../components/ui/Button';
import { Modal, ModalBody, ModalFooter } from '../../components/ui/Modal';
import { MemoryMaintenanceProgress } from './MemoryMaintenanceProgress';

export function MemoryMaintenanceProgressDialog({ operation, onClose, onClosed }: {
  operation: MemoryDockOperation; onClose: () => void; onClosed: () => void;
}) {
  const { t } = useTranslation();
  const title = operation.job.operation === 'reindex' ? t.memory.maintenanceReindex : t.memory.maintenanceRecategorize;
  return <Modal title={title} size="sm" presentation="center" onClose={onClose} onClosed={onClosed}
    aria-busy={operation.status === 'running' || undefined} data-testid="memory-operation-progress-dialog">
    <ModalBody><MemoryMaintenanceProgress job={operation.job} /></ModalBody>
    <ModalFooter>
      <Link className={buttonClassName("ghost")} href="/memory?maintenance=1" onClick={onClose}>{t.memory.maintenanceTitle}</Link>
      <Button variant="ghost" onClick={onClose}>{operation.status === 'running' ? t.operationProgress.minimize : t.common.close}</Button>
    </ModalFooter>
  </Modal>;
}
